import { render, staticRenderFns } from "./TextBubble.vue?vue&type=template&id=75d0697c&scoped=true&"
import script from "./TextBubble.vue?vue&type=script&lang=js&"
export * from "./TextBubble.vue?vue&type=script&lang=js&"
import style0 from "./TextBubble.vue?vue&type=style&index=0&id=75d0697c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d0697c",
  null
  
)

export default component.exports